import React from 'react';

import { AutoAttendRescheduleModal } from '@copilot/ui';
import * as botMeetingApi from '../../services/botMeetingApi';
import { botErrorInfo } from '../../utils/botMeetings';

// The shared reschedule modal, wired to Web's API client.
function RescheduleAutoAttendModal({ meeting, onClose, onRescheduled, onStale }) {
  return (
    <AutoAttendRescheduleModal
      meeting={meeting}
      onSubmit={(target, value) => botMeetingApi.rescheduleBotMeeting(target.meeting_id, value)}
      describeError={(err) => botErrorInfo(err, 'Unable to reschedule. Please try again.')}
      onClose={onClose}
      onRescheduled={onRescheduled}
      onStale={onStale}
    />
  );
}

export default RescheduleAutoAttendModal;
